import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { useDispatch, useSelector } from "react-redux";
import { logOut, setLogedinUserInfo } from "../../login/Login_reducer";
import { Cookies } from "react-cookie";
import store from "../../../store";
import { setProductAccessOfShop } from "../../dashboard/userDashboardReducer";
import { trainingcenterdata } from "../../traningModule/traningmoduleReducer";

export const ManagerHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectMenu, setselectMenu] = React.useState(null);
  const [productNavigation, setProductNavigation] = useState(null);
  const [trainingData, setTrainingData] = useState(null);

  ///////////////////////////For training Center Opening where it closed last training///////////////////////
  const [trainingID, setTrainingID] = useState(null);
  const [lessonID, setLessonID] = useState(null);
  const [trainingFullData, setTrainingFullData] = useState(null);

  useEffect(()=>{
    console.log("trainingFullData",trainingFullData);
  },[trainingFullData])

  const open = Boolean(anchorEl);

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const cookies = new Cookies();

  const backtoUser = () => {
    cookies.set("userInfo", cookies.get("originaluserInfo"), { path: "/" });
    cookies.set("lastLoginTime", cookies.get("originaluserlastLoginTime"), {
      path: "/",
    });
    // cookies.remove("secret", { path: '/' });
    // cookies.remove("token", { path: '/' });

    cookies.remove("originaluserInfo", { path: "/" });
    cookies.remove("originaluserlastLoginTime", { path: "/" });
    // cookies.remove("token", { path: '/' });
    store.dispatch(setLogedinUserInfo(cookies.getAll()));

    // handleClose()
    navigate("/users", { replace: true });
  };

  useEffect(() => {
    console.log("Location changed", trainingData);
  }, [trainingData]);

  const handleClick = (val, event) => {
    setselectMenu(val);

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const gotodashboard = () => {
    console.log("gotodashboard");
    navigate(`/${store.getState().loginUserKey.userInfo.type}-dashboard`, {
      replace: true,
    });
  };
  const gotosafety = () => {
    console.log("gotosafety");
    navigate("/safety-measurements", {
      replace: true,
    });
  };
  const showMenuBar = () => {
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };
  const goToVat = () => {
    navigate("/vat-list", { replace: true });

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };

  const goToProduct = () => {
    navigate("/product", { replace: true });

    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };

  const handleTrainingCenter = () => {
    console.log("trainingData11", trainingData, trainingID, lessonID);

    // console.log("trainingFullData", trainingFullData);
    const next_training_id =
      trainingFullData[
        trainingFullData.findIndex((cur) => cur?._id === trainingID) + 1
      ]?._id;
    // console.log("setTrainingFullData", next_training_id);
    if (trainingID == null) {
      navigate(`/trainingcenter/${trainingData}`, { replace: true });
    } else {
      if (lessonID == null) {
        navigate(`/trainingcenter/${next_training_id}`, { replace: true });
      } else {
        navigate(`/trainingcenter/${trainingID}/${lessonID}`, {
          replace: true,
        });
      }
    }
    setAnchorEl(null);
  };

  store.subscribe(() => {
    const storeData = store.getState();
    setProductNavigation(storeData.userDashboardKey.store_access);
    if (
      storeData.trainingManagmentReducer.trainingcenterdatas.training_data !=
        undefined &&
      storeData.trainingManagmentReducer.trainingcenterdatas.training_data
        .length > 0
    ) {
      setTrainingData(
        storeData.trainingManagmentReducer.trainingcenterdatas.training_data[0]
          ._id
      );
      setTrainingFullData(
        storeData.trainingManagmentReducer.trainingcenterdatas.training_data
      );
    }

    if (
      storeData.trainingManagmentReducer.training_id !== undefined &&
      storeData.trainingManagmentReducer.next_lesson_id !== undefined
    ) {
      setTrainingID(storeData.trainingManagmentReducer.training_id);
      setLessonID(storeData.trainingManagmentReducer.next_lesson_id);
    }
  });

  // const showMenuBarSub = () => {
  //   var elem = document.getElementById("topMenuLists");
  //   elem.classList.toggle("addCSS");

  // };

  useEffect(() => {
    // console.log("id++++++", paramid);
    store.dispatch(trainingcenterdata());
  }, []);

  return (
    <div className="pageWrapper">
      <Grid container spacing={0} className="topMenu">
        <Grid item xs={12} md={2} className="topLogo">
          <div className="loginFormLogo">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/fryright_images/logo.png"
              className="App-logo"
              alt="logo"
            />
          </div>
          <div className="navbarToggle" onClick={showMenuBar}>
            <Button id="fade-button">
              <Icon className="toggleMenu">clear_all</Icon>
            </Button>
          </div>
        </Grid>

        <Grid item xs={12} md={7} id="topMenuLists" className="topMenuLists">
          <div className="topMenuListsWrapper">
            <Button
              onClick={() => gotodashboard()}
              className={pathname.includes("manager-dashboard") ? "active" : ""}
            >
              Dashboard
            </Button>


            {/* <Button
              id="fade-button"
              onClick={() => goToVat()}
              className={pathname.includes("vat-list") ? "active" : ""}
            >
              Vat
            </Button> */}

            {/* {productNavigation == 1 && (
              <Button
                id="fade-button"
                onClick={() => goToProduct()}
                className={pathname.includes("product/list") ? "active" : ""}
              >
                Product
              </Button>
            )} */}


            {trainingData !== null && (
            <Button
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={() => handleTrainingCenter()}
              className={
                pathname.includes("list-training") ||
                pathname.includes("list-lessons") ||
                pathname.includes("trainingcenter")
                  ? "active"
                  : ""
              }
            >
              Training Center
            </Button>
            )}


            <Button
              id="fade-button"
              aria-controls={open ? "fade-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={() => gotosafety()}
              className={
                pathname.includes("safety-measurements") ? "active" : ""
              }
            >
              MSDS
            </Button>
            
          </div>
        </Grid>

        <Grid item xs={12} md={3} className="topRightMenu">
          <Button className="goToHome" onClick={() => navigate("/home")}>
            Go To Home
          </Button>
          <Button
            className="myAccount"
            id="fade-button"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(evt) => handleClick(7, evt)}
          >
            <Icon className="account_circle">account_circle</Icon>{" "}
            <Icon className="expand_more">expand_more</Icon>
          </Button>
        </Grid>
      </Grid>

      {selectMenu === 7 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem
            onClick={() => {
              navigate("/myaccount", { replace: true });
              setAnchorEl(false);
            }}
            className={pathname.includes("") ? "active" : ""}
          >
            My Account
          </MenuItem>
          {!cookies.get("originaluserInfo") ? (
            <MenuItem
              onClick={() => {
                dispatch(logOut());
                dispatch(setProductAccessOfShop({ store_access: null }));
                const cookies = new Cookies();
                cookies.remove("userInfo", { path: "/" });
                cookies.remove("secret", { path: "/" });
                cookies.remove("token", { path: "/" });
                cookies.remove("store_access", { path: "/" });
                handleClose();
                navigate("/", { replace: true });
                window.location.reload();
              }}
            >
              Log Out
            </MenuItem>
          ) : null}

          {cookies.get("originaluserInfo") ? (
            <MenuItem
              onClick={() => backtoUser()}
              // {() => {
              //   // dispatch(logOut())
              //   cookies.set("userInfo", cookies.get('originaluserInfo'), { path: '/' });
              //   cookies.set("lastLoginTime", cookies.get('originaluserlastLoginTime'),{ path: '/' });
              //   // cookies.remove("secret", { path: '/' });
              //   // cookies.remove("token", { path: '/' });

              //   cookies.remove("originaluserInfo", { path: '/' });
              //   cookies.remove("originaluserlastLoginTime", { path: '/' });
              //   // cookies.remove("token", { path: '/' });
              //  store.dispatch(setLogedinUserInfo(cookies.getAll()));

              //   handleClose()
              //   navigate('/users', { replace: true })
              // }}
            >
              Back to Original Account
            </MenuItem>
          ) : null}
        </Menu>
      )}
    </div>
  );
};
